import { Link } from "react-router-dom";

/**
 * Compact "X / Y used this month" indicator for a single metered feature.
 *
 * Renders nothing for anonymous users (no `item`). Shows an Upgrade link when the feature isn't
 * included in the plan or the monthly limit is reached.
 *
 * @param {{ item: Object | null | undefined; label?: string; className?: string }} props Item — a
 *   single entry from /user/usage features[]
 */
export default function UsageMeter({ item, label = "this month", className = "" }) {
  if (!item) return null;

  const { used, limit, remaining, unlimited, included } = item;
  const base = `text-xs flex items-center gap-1.5 ${className}`;

  if (!included) {
    return (
      <p className={`${base} text-on-surface-variant`}>
        Not included in your plan.
        <Link to="/pricing" className="text-primary font-medium hover:underline">
          Upgrade
        </Link>
      </p>
    );
  }

  if (unlimited) {
    return (
      <p className={`${base} text-on-surface-variant`}>
        {used} used {label} · Unlimited
      </p>
    );
  }

  const left = remaining ?? limit - used;

  if (left <= 0) {
    return (
      <p className={`${base} text-error font-medium`}>
        Monthly limit reached ({used}/{limit}).
        <Link to="/pricing" className="text-primary font-medium hover:underline">
          Upgrade
        </Link>
      </p>
    );
  }

  return (
    <p className={`${base} text-on-surface-variant`}>
      {left} of {limit} left {label}
    </p>
  );
}
